module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapitre Un")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— CE")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v(" n’était pas une demande")]), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(", ")]), _vm._v("Crawford. Helena t’a réservé un vol pour Vancouver la semaine prochaine et je m’attends à ce que tu y sois.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crawford garda un air parfaitement impassible, ses yeux braqués juste au-dessus de l’épaule de son chef sur le Warhol accroché derrière lui. L’objet en lui-même était horriblement cher, surtout sachant qu’il était exposé sur le mur d’un homme qui n’appréciait même pas l’art. C’était lui qu’on avait envoyé à la vente pour y enchérir. George avait affirmé que c’était exactement le type de chefs-d’œuvre qu’on trouvait dans le bureau du PDG d’une chaîne de boutique-hôtels internationale très fructueuse.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Participer à des ventes d’art ne faisait techniquement pas partie de son travail. Mais récemment, George s’était mis à étendre de plus en plus les fonctions de Crawford pour justifier de l’envoyer faire des tâches aussi ridicules que traverser la moitié du pays pour prendre part à des enchères avec l’architecte d’intérieur de leur compagnie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crawford se concentra entièrement sur le tableau tape-à-l’œil et invoqua toute la patience qui lui restait. Son cœur battait à tout rompre depuis que George avait annoncé devant tout le Conseil que Crawford allait être en charge de l’audit de l’hôtel canadien le plus prisé de leur compagnie. La nouvelle en elle-même n’avait pas été une grande surprise. Le domaine de Vancouver était sur la mauvaise pente depuis déjà plusieurs trimestres. Les chiffres ne convenaient plus aux attentes et ne pouvaient plus se mesurer aux gains de leurs établissements nord-américains – très loin des prévisions que Crawford en personne avait participé à établir. Étant le contrôleur principal et le consultant en chef en gestion, il s’était attendu à recevoir une telle affectation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Au vu de l’ampleur de l’affaire, cela n’avait pas été très surprenant non plus d’apprendre qu’il ferait partie d’une équipe d’inspecteurs au lieu de s’y rendre en solo comme il le faisait souvent.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Et si cela avait été avec l’un des six consultants nord-américains avec lesquels il avait déjà travaillé par le passé, il serait déjà dans son bureau, plongé dans les dossiers afin de se préparer pour le déplacement. Mais le chef du comité avait décidé de faire appel à son homologue européen, ce qui était le plus rédhibitoire pour lui. George savait exactement ce qu’il demandait en vérité à Crawford en prenant de telles mesures. Tout le monde à "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Chatham-Thompson ")]), _vm._v("savait pourquoi Crawford tenait les bureaux européens et toute communication avec son homologue à distance. Ce n’était pas comme si Crawford et Davis avaient caché leur relation. Ils avaient été ensemble pendant trois ans. La moitié de leurs collaborateurs étaient même venus à leur mariage, pour l’amour de Dieu.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crawford fit une grimace en frottant une main sur sa mâchoire. L’une des dernières choses pour le moins civiles que Davis lui avait dites, c’était qu’il souhaitait qu’aucune rancune ne naisse entre eux à l’idée qu’il accepte la promotion qui l’enverrait à l’autre bout du monde. Comme si leur mariage n’avait rien signifié. Comme si le temps passé ensemble ne se résumait qu’à l’attente de son heure avant que Davis grimpe l’échelon suivant sur l’échelle de la hiérarchie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il allait sans dire que Crawford n’avait pas été aussi cordial à son égard par la suite. Après plusieurs conférences téléphoniques désastreuses, les autres cadres avaient réalisé l’importance de planifier leurs réunions avec ces deux-là séparément, et ils faisaient dorénavant bien attention de le faire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jusqu’à aujourd’hui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _vm._v("George, Edward s’est lui-même proposé pour superviser l’audit, répliqua Crawford. Et avec tout le respect que je vous dois, vous n’avez pas besoin de Davis "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("et")]), _vm._v(" moi là-dessus. Ce serait plus logique d’envoyer un adjoint qui connaît les lieux afin d’aider Davis à vérifier les chiffres et discuter avec le personnel. Lui et moi ensemble, ce serait redondant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crawford fut fier de constater que sa voix n’avait pas tremblé. Ses mains étaient la seule partie de son corps à le trahir, mais elles étaient serrées en poing sur ses genoux, cachées par l’énorme bureau en chêne de George.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _vm._v("Edward est quelqu’un de très compétent, accepta George avec un calme trompeur qui précédait toujours ses discours les moins populaires.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le mentor de Crawford était étrangement doué lorsqu’il s’agissait de cerner les gens et de les pousser hors de leur zone de confort. Toujours dans l’intérêt d’une croissance professionnelle, bien sûr. Son ventre se noua. Il voyait d’ici George vouloir s’immiscer dans ce qui ne le concernait pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _vm._v("Je vais être franc avec vous, Crawford. Vous avez raison. Un de vos adjoints pourrait sans doute s’occuper de cette affaire. Pour ce qui est des entretiens et de la collecte de données sur place, du moins. Mais je pensais que ce serait une chance pour vous de prouver au Conseil que vous êtes sérieux à propos de l’avenir que vous envisagez chez nous, à "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Chatham-Thompson")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crawford serra les dents. Il avait travaillé pour cette compagnie durant plus de la moitié de sa vie, débutant comme réceptionniste comme tous les nouveaux, pour être promu en l’espace de deux ans à la conciergerie du plus gros hôtel de la chaîne. Peu après, il était monté en grade en intégrant le siège social, travaillant jusqu’à l’épuisement quatre-vingts heures par semaine, tout en révisant de son côté afin d’obtenir sa maîtrise en gestion. Cela avait fini par payer. À l’âge de trente-quatre ans, il avait finalement atteint la vice-présidence.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je suis sérieux à propos de Chatham-Thompson")]), _vm._v(". Ne soyez pas ridicule, lança Crawford.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il avait tout donné pour cette compagnie. Des semaines de travail atrocement longues, des années pendant lesquelles il avait préféré oublier ses congés, car il était trop occupé à faire croître cette entreprise pour les prendre – chose ironique, vu qu’il travaillait pour la plus grande chaîne de complexe hôtelier du monde. Après George, il était l’employé le plus dévoué de toute la direction. Il ne voyait simplement pas la nécessité de se forcer à travailler avec son ex-mari pour le prouver.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— La décision a déjà été prise, Crawford")]), _vm._v(", dit George. Je sais que ce n’est pas toujours facile pour vous, mais cela fait déjà trois ans. Il faut que vous passiez à autre chose. J’ai trop longtemps laissé passer votre petite rivalité, mais cela commence à affecter notre rentabilité. Et cela, je ne peux pas me le permettre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("George se leva pour signifier la fin de la conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Votre vol est réservé. Je suppose que vous allez loger sur place, comme d’habitude ?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crawford était trop ahuri pour faire quoi que ce soit d’autre qu’opiner de la tête en guise d’assentiment. Il s’était fait avoir et sa poitrine lui faisait aussi mal que s’il avait percuté un train à pleine vitesse.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Parfait")]), _vm._v(". Helena s’occupera d’envoyer tous les détails à votre assistant. Nous planifierons une conférence téléphonique une fois que vous serez installé et que vous aurez fait votre enquête préliminaire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lorsque les yeux de George se portèrent de nouveau sur la tablette en face de lui, il se considéra comme congédié. Il avait manifestement dit tout ce qu’il avait à dire, et alors même que le monde de Crawford s’effondrait tout autour de lui, il en restait froidement inconscient.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crawford avait envie de débattre, d’adopter une position ferme et de refuser, mais il ne pensait pas qu’il gagnerait cette partie. George irait-il jusqu’à le renvoyer ? Éviter Davis valait-il de ruiner toute sa carrière ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ce n’était pas la première fois que Crawford se demandait à quoi ressemblerait sa vie s’il n’avait pas accepté la première promotion qui l’avait vraiment lancé dans l’entreprise. Son travail de concierge lui plaisait et il rêvait à cette époque de pouvoir un jour être à la tête de son propre hôtel. Encore aujourd’hui, la partie de son travail qu’il préférait était de se rendre dans les hôtels et d’être en contact avec les clients. À présent, il n’avait plus l’occasion de le faire aussi souvent qu’auparavant et lorsqu’il l’avait, c’était habituellement avec des clients mécontents logeant dans des hôtels en difficultés. Mais c’était quand même beaucoup mieux que de rester assis dans un bureau étouffant à étudier des rubriques budgétaires.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("George releva les yeux, les sourcils haussés, comme s’il était surpris de voir Crawford encore dans son bureau.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Nous nous sommes bien compris ?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il n’essaya même pas de sourire lorsqu’il se releva pour disposer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Parfaitement")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d59fd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0